import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import "./Operaciones_style.css";
import EditIcon from "@material-ui/icons/Edit";
import { ExoneracionesModFormValues } from "../../app/models/ExoneracionesMod";
import { IconButton } from "@material-ui/core";
import UpdateExoneracion from "../Modals/UpdateExoneracion";

export default observer(function TablaExo() {
  const {
    userStore: { user, logout, isLoggedIn, roles },
    CuotasStore,
    ExoneracionesStore,
    modalStore,
  } = useStore();
  const { loadCuotas } = CuotasStore;
  const { PlanCuotas, loadExoneraciones, dpiByCodigo } = ExoneracionesStore;
  const { CCTOperacionStore, CuentaDPIStore } = useStore();
  const {
    createCCTOperacion,
    getTransacciones,
    TransaccionByCodigo,
    TransaccionRegistry,
    personaDPI,
    kk,
    inputPersona,
    CCTCuentaByCodigo,
  } = CCTOperacionStore;

  return (
    <div id="contenedor_busqueda_movimiento">
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>No.</b>
              </TableCell>
              <TableCell align="center">
                <b>Curso</b>
              </TableCell>
              <TableCell align="center">
                <b>Exoneracion solicitada</b>
              </TableCell>
              <TableCell align="center">
                <b>Alumno</b>
              </TableCell>
              <TableCell align="center">
                <b>Solicitado Por</b>
              </TableCell>
              <TableCell align="center">
                <b>Aprobado Por</b>
              </TableCell>
              <TableCell align="center">
                <b>Fecha de Solicitud</b>
              </TableCell>
              <TableCell align="center">
                <b>Fecha Aprobación</b>
              </TableCell>
              <TableCell align="center">
                <b>Porcentaje Solicitado</b>
              </TableCell>
              <TableCell align="center">
                <b>Razón de la Solicitud</b>
              </TableCell>
              <TableCell align="center">
                <b>Comentario</b>
              </TableCell>
              <TableCell align="center">
                <b>Estado</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dpiByCodigo.map((personai) => {
              //console.log("ver", personai)
              var PlanCuotas: ExoneracionesModFormValues;
              return (
                
                  <TableRow key={personai.idcontrol}>
                    <TableCell component="th" scope="row" align="center">
                      {personai.idcontrol}
                    </TableCell>

                    <TableCell align="center">{personai.catCurso}</TableCell>
                    <TableCell align="center">
                      {personai.transacciones}
                    </TableCell>
                    <TableCell align="center">{personai.alumno}</TableCell>
                    <TableCell align="center">
                      {personai.solicitado_por}
                    </TableCell>
                    <TableCell align="center">
                      {personai.aprobado_por}
                    </TableCell>
                    <TableCell align="center">
                      {personai.fecha_de_solicitud}
                    </TableCell>
                    <TableCell align="center">
                      {personai.fecha_de_aprobacion}
                    </TableCell>
                    <TableCell align="center">
                      {personai.porcentaje_de_solicitud}
                    </TableCell>
                    <TableCell align="center">
                      {personai.razon_de_solicitud}
                    </TableCell>
                    <TableCell align="center">{personai.comentario}</TableCell>
                    <TableCell align="center">{personai.estado}</TableCell>
                    {roles()?.map((rol: any) => {
                      if (rol == "Exonerar") {
                        return (
                          <IconButton
                          key={`edit_${personai.idcontrol}`}
                            aria-label="edit"
                            onClick={() => {

                              modalStore.openModal(
                                <UpdateExoneracion
                                  idControl={personai.idcontrol}
                                  dpis={personai.alumno}
                                />,
                                'mini'
                              );
                            }}
                          >
                            {" "}
                            <EditIcon />
                          </IconButton>
                        );
                      }
                    })}
                  </TableRow>
                
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
});
